export default __webpack_public_path__ + "static/media/paymentSuccess.db19a0f6.png";